import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'



class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            margin-top: 100px;            
        `

        const Heading2 = styled.h2`
            font-size: 40px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #C1EB18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const BottomContent = styled.div`
            position: relative;
            width: 100%;
            padding-bottom: 100px;            
            @media (min-width:1025px) and (max-width: 1400px) {    
                bottom: -35%;
            }
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading = styled.h3`
            font-size: 25px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `

        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 14px;
            font-weight: 300;
            color: #c5c5c5;
        `

        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #c5c5c5;
            padding-bottom: 30px;
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `

        const Heading2b = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            color: #fff;
            line-height: 70px;
            text-align: center;
            padding-bottom: 80px;        
        `

        return (
            <Section>
                <Container>
                    <Content>
                        <Heading2>
                            RAID 10: Velocidad y Seguridad para tu VPS
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="Servidor VPS en Colombia con soporte 24/7" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            ¿Qué es RAID 10?
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            RAID 10 combina la velocidad de RAID 0 con la redundancia de RAID 1, ofreciendo un equilibrio perfecto para
                                            VPS en Colombia. Tus datos están protegidos y tus aplicaciones corren rápido, ya sea en Bogotá, Pereira, o Cali.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Infraestructura VPS en Bogotá para empresas" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Velocidad y rendimiento inigualables
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Con VPS RAID 10, disfruta de tiempos de carga ultrarrápidos en Medellín y Bogotá, mejora el SEO de tu sitio, y asegura
                                            la continuidad de tu negocio con redundancia de datos. Ideal para e-commerce y aplicaciones críticas.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>

                <Container>
                    <Content>

                        <Heading2>
                            VPS No Administrado: Control Total en Colombia
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Centro de datos VPS en Texas con alta disponibilidad" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Libertad de configuración
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Nuestros VPS no administrados en Bogotá y Pereira te dan control total. Configura CentOS, Debian, o Ubuntu
                                            según tus necesidades, ideal para desarrolladores y empresas tecnológicas.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image4} alt="Soluciones VPS escalables en Cali" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Optimizado para usuarios en Colombia
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Con datacenters en Texas optimizados para Colombia, disfruta de baja latencia en Cali, Medellín, y Bogotá.
                                            Perfecto para aplicaciones que requieren alta personalización.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>

                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            <Heading2b>Garantía de reembolso por 30 días</Heading2b>
                            <Text>
                                Garantizamos tu satisfacción. Si en los primeros 30 días no estás completamente satisfecho,
                                te reembolsamos sin preguntas. Tu confianza es nuestra prioridad.</Text>
                        </Col>
                    </Row>
                </AboutContainer>

                <Container>
                    <Content>

                        <Heading2>
                            Rendimiento Superior para tu VPS en Colombia
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image5} alt="Servidor VPS en Barranquilla con baja latencia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Sistemas Operativos Linux
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Elige entre AlmaLinux y Ubuntu para tu VPS en Bogotá o Pereira. Nuestra instalación automatizada
                                            te permite empezar en minutos, sin complicaciones.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image6} alt="Alojamiento VPS en Colombia con IP local" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Optimizado para SEO y velocidad
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Con LiteSpeed y CPU E5v4, tu VPS en Medellín o Cali impulsa el rendimiento de WordPress y mejora el
                                            posicionamiento en Google, clave para negocios digitales.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image7} alt="VPS SSD en Colombia para tiendas online" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Recargas Ilimitadas del Sistema Operativo
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Mantén tu VPS en Bogotá fresco con reinicios ilimitados. Asegura un rendimiento constante para tus
                                            aplicaciones, desde e-commerce hasta APIs.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image8} alt="Servidor VPS en Miami con ancho de banda ilimitado" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Soporte 24/7 en Español: Siempre contigo
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Disfruta de soporte técnico 24/7 en español para tu VPS, ya sea en Miami, Ciudad de México, Bogotá o
                                            Pereira. Nuestro equipo garantiza soluciones rápidas para mantener tu negocio en línea sin interrupciones.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>

                <Container>
                    <Content>

                        <Heading2>
                            VPS en Bogotá, Pereira, Cali, Bucaramanga y Medellín
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image9} alt="VPS en Medellín para alojar aplicaciones empresariales" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            VPS Bogotá: Potencia para PYMES
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Nuestros servidores VPS SSD en Bogotá ofrecen RAID 10 y soporte 24/7, ideales para PYMES que buscan rendimiento y
                                            estabilidad en la capital.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image9} alt="Servidor virtual colombiano con alta velocidad y uptime garantizado" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            VPS Pereira: Rapidez local
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Aprovecha nuestra fuerte presencia en Pereira para VPS rápidos y confiables, perfectos para negocios en Risaralda.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image9} alt="Alojamiento VPS en Bucaramanga con soporte técnico en español" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            VPS Bucaramanga: Soluciones para Santander
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            En Bucaramanga, nuestros VPS SSD con RAID 10 y soporte 24/7 impulsan negocios locales, desde startups hasta e-commerce,
                                            con velocidad y confianza.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image9} alt="Servidor VPS en Santander ideal para proyectos web exigentes" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            VPS Cali y Medellín: Crece en el mercado
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Expande tu negocio en Cali o Medellín con VPS no administrados desde $90.000/mes. Baja latencia y soporte 24/7 garantizados.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/raid-10.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/litespeed.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/preferences.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image4: file(relativePath: { eq: "icons/flagpoint.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image5: file(relativePath: { eq: "icons/linuxserver.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image6: file(relativePath: { eq: "icons/report.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image7: file(relativePath: { eq: "icons/reload.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image8: file(relativePath: { eq: "icons/soporte.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
            image9: file(relativePath: { eq: "icons/location.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
            const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
            const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);
            const image7 = getImage(data.image7.childImageSharp.gatsbyImageData);
            const image8 = getImage(data.image8.childImageSharp.gatsbyImageData);
            const image9 = getImage(data.image9.childImageSharp.gatsbyImageData);
            return <Hero data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6} image7={image7} image8={image8} image9={image9}{...props} />;
        }}
    />
);

export default Iconos;
